import React from "react";
import { PageHero } from "../components/PageHero";
import { FadeUp, Button, Marquee } from "../components/primitives";
import { useLang } from "../i18n";

const About = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden">
      <PageHero over={t.about.heroOver} title={t.about.heroTitle} sub={t.about.heroSub} />

      <Marquee words="WE ARE NATION MEDIA" />

      <section className="py-20 md:py-28 bg-white">
        <div className="mx-auto max-w-[1300px] px-5 md:px-10">
          {t.about.chapters.map((c, i) => (
            <FadeUp key={i}>
              <div className="grid md:grid-cols-[220px_1fr] gap-6 md:gap-16 py-14 border-t border-wanm-dark/10 items-start">
                <div className="flex items-start gap-4">
                  <span className="text-7xl md:text-8xl font-black wanm-gradient-text leading-none">{c.n}</span>
                </div>
                <div>
                  <h2 className="text-3xl md:text-5xl font-black tracking-tight text-wanm-dark">{c.t}</h2>
                  <p className="mt-5 text-lg md:text-2xl text-wanm-dark/60 leading-relaxed max-w-2xl">{c.d}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="py-24 wanm-gradient-bg relative overflow-hidden grain">
        <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-10 text-center">
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter text-white">{t.home.finalTitle}</h2>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="dark" to="/contact">{t.cta.talk}</Button>
            <Button variant="outlineLight" to="/for-publishers">{t.cta.publisher}</Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
